export default "__VITE_ASSET__D58JKc4s__"